var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(context, insertable) {
  if (insertable.type === 1 && context.registered["css-" + insertable.name] === undefined) {
    context.registered["css-" + insertable.name] = insertable.styles;
  }

  function _ref(rule) {
    context.sheet.insert(rule);
  }

  if (context.inserted[insertable.name] === undefined) {
    var rules = context.stylis(insertable.type === 1 ? ".css-" + insertable.name : '', insertable.styles);
    context.inserted[insertable.name] = rules.join('');

    if (isBrowser) {
      rules.forEach(_ref);
    }

    return context.inserted[insertable.name];
  }
};

export { isBrowser, getRegisteredStyles, insertStyles };
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/utils/dist/index.es.js